export default __webpack_public_path__ + "static/media/imgIntro2.904a3969.jpg";